import { MrbBaseRouteStore } from "mrb/core";
import { CertifiedModeService } from "common/services";

class AdminCertifiedModeEditRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(CertifiedModeService);
    }

    async getCertifiedMode(id) {
        const response = await this.service.get(id, { embed: "certifiers,certifiers.user" });
        return response.data;
    }

    async createCertifiedMode(resource) {
        const response = await this.service.create(resource);
        return response.data;
    }

    async updateCertifiedMode(resource) {
        const response = await this.service.update(resource);
        return response.data;
    }

    async findUsers(params) {
        const response = await this.rootStore.application.baasic.membershipModule.user.find(params);
        return response.data;
    }
}

export default AdminCertifiedModeEditRouteStore;
